import fetcher from '../fetcher'

import type { DifficultyLevel } from './types'
import config from '../../config'

/**
 * Returns all difficulty levels.
 * @returns Array<DifficultyLevels>
 */
export const getAllDifficultyLevels = async (): Promise<Array<DifficultyLevel>> => {
  try {
    const res = await fetcher(`${config.VITE_ZRIVE_API_URL}/api/difficulty-levels`, {
      method: 'GET'
    })
    return res.data
  } catch (error: unknown) {
    console.error(`Error fetching difficulty levels: ${error}`)
    throw error
  }
}
